import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { combineReducers } from 'redux';
import { FlowId } from "../../constants";
import createDefaultFlowReducers from "./default-flow-reducers";
export default combineReducers(_objectSpread({}, createDefaultFlowReducers(FlowId.CREDIT_SCORE)));